/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ProgramTaskActionType {
    GAMES = 'games',
    SLEEP = 'sleep',
    STEPS = 'steps',
    SOCIAL_INTERACTION = 'socialInteraction',
    STRESS = 'stress',
    DIET = 'diet',
}
